import { UseFormReturnType } from "@mantine/form"
import { pathProxy, PathProxy } from "../../utils/forms-proxy"
import { MantineFormContext } from "./mantine-form-context"
import { useMemo } from "react"

export function useFormContext<Values>(): [
  UseFormReturnType<Values, (values: Values) => Values>,
  PathProxy<Values, Values>,
  React.RefObject<HTMLFormElement>,
] {
  const _ = useMemo(() => pathProxy<Values>(), [])
  const ctx = React.useContext(MantineFormContext) // as unknown as UseFormReturnType<Values>
  if (!ctx) throw new Error("useFormContext must be used inside Form component")
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return [ctx[0] as any, _, ctx[1]] as any
}
